<template>
  <div class="ss-card-container">
    <custom-skeleton-loader :LoadingFlag="SkeletonLoadingFlag" />
    <div v-if="!SkeletonLoadingFlag" class="card-content">
      <!-- Status Section -->
      <div class="status-section">
        <div class="section-icon">
          <v-icon>mdi-check-circle</v-icon>
        </div>
        <div class="section-content">
          <div class="section-label">Document Status</div>
          <v-chip draggable dark small :color="Document.LomDocumentStatusColor" text-color="white" class="status-chip">
            {{ ResultFlag ? Document.LomDocumentStatusTxt : "Pending" }}
          </v-chip>
        </div>
      </div>

      <!-- Document Section -->
      <div class="document-section">
        <div v-if="Document.LomDocumentFlag" class="document-available">
          <div class="document-header">
            <v-icon>mdi-file-pdf-box</v-icon>
            <span class="document-title">Specimen Signature Card</span>
          </div>
          <p class="document-info">Document has been uploaded and verified</p>
          <v-btn :href="Document.DocumentAssetPath" target="_blank" class="download-btn">
            <v-icon left>mdi-download</v-icon>
            Download Document
          </v-btn>
        </div>

        <div v-else class="document-empty">
          <div class="empty-icon">
            <v-icon size="48">mdi-file-upload</v-icon>
          </div>
          <h4 class="empty-title">No Document Uploaded</h4>
          <p class="empty-text">Please upload your Specimen Signature Card</p>
          <v-btn class="upload-btn" @click.prevent="uploadDocumentPrompt = true">
            <v-icon left>mdi-cloud-upload</v-icon>
            Upload Document
          </v-btn>
        </div>
      </div>

      <v-dialog v-model="uploadDocumentPrompt" persistent max-width="70%">
        <voting-rights-create pageTitle="Upload Specimen Signature Card" :addRecordPrompt="uploadDocumentPrompt"
          @hideAddRecordPrompt="hideUploadRecordPrompt" v-if="uploadDocumentPrompt"></voting-rights-create>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import VotingRightsCreate from "../voting-rights/VotingRightsCreate.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";
export default {
  mixins: [common],
  components: {
    VotingRightsCreate,
  },
  data() {
    return {
      uploadDocumentPrompt: false,
      EditRecordPrompt: false,

      SkeletonLoadingFlag: true,

      EligibleCount: 0,
      selectedData: {},
      Document: {},
      ResultFlag: false,

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      JciYearCode: "",
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
    };
  },
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });
        this.JciYearCode = CurrentJciYearId;

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        var NextJciYearId = parseInt(tr.NextJciYearId);
        console.log({ NextJciYearId });
        this.NextYearCode = NextJciYearId;

        var NextJciYearName = parseInt(tr.NextJciYearName);
        console.log({ NextJciYearName });
        this.NextYearName = NextJciYearName;

        this.CurrentYearId = NextJciYearId;

        var LomId = this.$session.get("LomId");
        LomId = LomId == (null || undefined) ? "" : LomId;
        this.LomCode = LomId;

        var server_url = companyConfig.apiURL;
        console.log("server_url = " + server_url);
        var SampleFilePath = server_url + "assets/sample/voting_rights.pdf";
        console.log("SampleFilePath = " + SampleFilePath);
        this.SampleFilePath = SampleFilePath;
      }
    },
  },
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "voting_rights",
        Action: "list",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
      this.pageData();
    },
    pageData() {
      console.log("pageData called");
      this.getTableRecords();
    },
    hideUploadRecordPrompt(flag) {
      console.log("hideUploadRecordPrompt called");
      this.uploadDocumentPrompt = false;
      if (flag) {
        this.getTableRecords();
      }
    },
    getTableRecords() {
      console.log("getTableRecords called");

      this.SkeletonLoadingFlag = true;
      this.Document = {};
      this.ResultFlag = false;

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/lom-document/show";
      var upload = {
        UserInterface: 3,
      };
      console.log("upload=" + JSON.stringify(upload));
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );

      const thisIns = this;
      var output = "";
      var flag = 0;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        }.bind(this),
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));

          thisIns.SkeletonLoadingFlag = false;

          output = response.data.output;
          flag = response.data.flag;
          console.log("output=" + output + ", flag=" + flag);

          var records = response.data.records;
          console.log({ records });

          if (flag) {
            thisIns.ResultFlag = true;
            thisIns.Document = records;
            // thisIns.toast("success", output);
          } else {
            // thisIns.toast("error", output);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.SkeletonLoadingFlag = false;
        });
    },
  },
  mounted() { },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>

<style lang="scss" scoped>
.ss-card-container {
  width: 100%;

  .card-content {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .status-section {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px;
    background: linear-gradient(135deg, rgba(58, 103, 177, 0.08) 0%, rgba(58, 103, 177, 0.05) 100%);
    border-radius: 12px;
    border-left: 4px solid #3a67b1;
  }

  .section-icon {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    background: #3a67b1;
    border-radius: 50%;
    color: white;
  }

  .section-content {
    flex: 1;
  }

  .section-label {
    font-size: 11px;
    font-weight: 600;
    color: #414042;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 6px;
  }

  .status-chip {
    font-weight: 600 !important;
  }

  .document-section {
    padding: 0;
  }

  .document-available {
    background: linear-gradient(135deg, #f0f7ff 0%, #f0f4f8 100%);
    border: 2px solid #3a67b1;
    border-radius: 12px;
    padding: 20px;

    .document-header {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-bottom: 12px;

      .v-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        background: #3a67b1;
        border-radius: 50%;
        color: white;
        font-size: 20px;
      }
    }

    .document-title {
      font-size: 16px;
      font-weight: 700;
      color: #0a0f29;
    }

    .document-info {
      font-size: 13px;
      color: #414042;
      margin: 8px 0 16px 0;
    }
  }

  .document-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    padding: 40px 20px;
    background: linear-gradient(135deg, #fff9c4 0%, #fffde7 100%);
    border: 2px dashed #edbe38;
    border-radius: 12px;
    text-align: center;

    .empty-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 80px;
      height: 80px;
      background: linear-gradient(135deg, #edbe38 0%, darken(#edbe38, 10%) 100%);
      border-radius: 50%;
      color: white;
      box-shadow: 0 8px 16px rgba(237, 190, 56, 0.2);
      margin-bottom: 8px;
    }

    .empty-title {
      font-size: 16px;
      font-weight: 700;
      color: #0a0f29;
      margin: 0;
    }

    .empty-text {
      font-size: 13px;
      color: #414042;
      margin: 0;
    }
  }

  .download-btn {
    background: linear-gradient(135deg, #3a67b1 0%, darken(#3a67b1, 10%) 100%) !important;
    color: white !important;
    padding: 10px 20px !important;
    border-radius: 8px !important;
    font-weight: 600 !important;
    transition: all 0.3s ease !important;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 20px rgba(58, 103, 177, 0.3);
    }
  }

  .upload-btn {
    background: linear-gradient(135deg, #edbe38 0%, darken(#edbe38, 10%) 100%) !important;
    color: white !important;
    padding: 10px 24px !important;
    border-radius: 8px !important;
    font-weight: 600 !important;
    transition: all 0.3s ease !important;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 20px rgba(237, 190, 56, 0.3);
    }
  }
}
</style>

<style scoped>
.v-sheet--offset {
  top: -24px;
  position: relative;
}
</style>